import httpClient from 'api/httpClient';
import { AxiosRequestConfig } from 'axios';
import {
  WitnessedDocumentViewedEventProps,
  WitnessedListingVisitedEventProps,
} from 'models/MixpanelEvents';

function witnessedDocumentViewed(payload: WitnessedDocumentViewedEventProps) {
  return httpClient.post('mixpanel/witnessed-document-viewed', payload);
}

function witnessedListingVisited(
  payload: WitnessedListingVisitedEventProps,
  config?: AxiosRequestConfig,
) {
  return httpClient.post('mixpanel/witnessed-listing-visited', payload, config);
}

export default {
  witnessedDocumentViewed,
  witnessedListingVisited,
};
